import React, { useContext, useState } from "react";
import styles from "./styles.module.scss";
import { InputWapper } from "@/styles/homeStyles";
import AppContext from "../../hooks/appContext";
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import FilterListRoundedIcon from '@mui/icons-material/FilterListRounded';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import ButtonSearch from "../ButtonSearch";

const SubHeading = (props) => {

  const {
    toggleCartModal,
    toggleFilterModal,

    currentCurrency,
    chooseCurrency,
    cart,
  } = useContext(AppContext);

  const [openCurrencySelect, setOpenCurrencySelect] = useState(false);

  const setStoreCurrency = (currencyCode) => {
    chooseCurrency(currencyCode);
    setOpenCurrencySelect(false);
  }

  return (
    <>
      <div className={styles['sub-heading']}>
        <div className={styles['sub-heading-top']}>
          <a href="https://dashboard.squadco.com/sign-up">
            <div className={styles['setup-btn']}>Set Up Your Store For Free</div>
          </a>
        </div>
        
        <div className={styles['sub-heading-bottom']}>
          <div className={styles['search-products']}>
            <InputWapper>
              {/* <Input type="text" className="" placeholder="Search this store... "
                onChange={(e) => props.changeQuery(e.target.value)}
              /> */}
              <ButtonSearch 
                placeholder="Code"
                button="Apply"
                name="couponCode"
                onChange={(e) => props.changeQuery(e.target.value)}
                // checkCode={applyCoupon}
              />
            </InputWapper>
          </div>

          <div className={styles['currency-dropdown']}>
            <div className={styles['currency-box']} onClick={() => setOpenCurrencySelect(!openCurrencySelect)}>
              <div className={styles['currency-code']}>{currentCurrency}</div> <ExpandMoreRoundedIcon />
            </div>

            {
              openCurrencySelect &&
              <div className={styles['currency-select']}>
                <div className={styles['select-option']} onClick={() => setStoreCurrency("NGN")}>
                  NGN
                </div>

                <div className={styles['select-option']} onClick={() => setStoreCurrency("USD")}>
                  USD
                </div>
              </div>
            }
          </div>

          <div className={styles['sub-cart']}>
            <div className={styles['cart-icon-box']} onClick={toggleCartModal}>
              <ShoppingCartOutlinedIcon className={styles['cart-icon']} /> Cart
              <div className={styles['cart-count']}>{cart.length}</div>
            </div>
          </div>

          <div className={styles['filter-btn']} onClick={toggleFilterModal}>
            <FilterAltOutlinedIcon />
          </div>
        </div>
        
      </div>
    </>
  )
}

export default SubHeading;